/**
 * @fileoverview React message display block for event feed messages.
 */

import React from 'react';

import { MessagePayload } from 'client-web-app';
import { LoadingSpinner } from 'loading-spinner';

export interface MessageDisplayProps {
  clientId: number | string;
  isFormattingEnabled?: boolean;
  isBookkeeper?: boolean;
  isInProgress?: boolean;
  payload?: string;
  sentWithSms?: boolean;
}

const MessageDisplay: React.FC<MessageDisplayProps> = ({
  clientId,
  isFormattingEnabled = false,
  isBookkeeper = false,
  isInProgress = false,
  payload = '',
  sentWithSms = false,
}) => (
  <div
    className={[
      'bl-card_section-padded-medium',
      'bl-message_message-container_assets_asset',
      'bl-message_message-container_assets_message',
      sentWithSms ? 'sms' : '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <div className="bl-message_in-progress">
      {isBookkeeper && isInProgress ? <LoadingSpinner /> : null}
    </div>

    {!isInProgress || !isBookkeeper ? (
      <div>
        <MessagePayload
          clientId={String(clientId)}
          payload={payload}
          isNewMessageFormattingEnabled={isFormattingEnabled}
        />
      </div>
    ) : null}
  </div>
);

export default MessageDisplay;
